export enum RUMContextKeys {
  DD_CTX_BASE_URL_CONSUMER = 'even.base_url.consumer',
  DD_CTX_BASE_URL_PARTNERPAGE = 'even.base_url.partnerpage',
  DD_CTX_BRAND_FROM_HOST = 'even.brand.from_host',
  DD_CTX_COMPANY_UUID = 'even.company.uuid',
  DD_CTX_LEAD_UUID = 'even.lead.uuid',
  DD_CTX_LEAD_RETURNING = 'even.lead.returning',
  DD_CTX_RESULTS_UUID = 'even.results.uuid',
  DD_CTX_SESSION_UUID = 'even.session.uuid',
  DD_CTX_TRACKING_UUID = 'even.tracking.uuid',
  DD_CTX_APPLICATION_STEP = 'even.application.step',
  DD_CTX_APPLICATION_PRODUCT = 'even.application.product',
  DD_CTX_EXPERIMENTS = 'even.experiments',
}

export enum RUMTimingEvents {
  EMBED_STEP_FUNCTIONAL = 'embed_step_functional',
}

export enum RUMErrorKeys {
  TRUSTPILOT_LOAD_ERROR = 'embed_loading_trustpilot_error',
  TRUSTEDSITE_LOAD_ERROR = 'embed_loading_trustedsite_error',
}

export enum RUMEventKeys {
  RATE_TABLE_UTILIZED_CACHE = 'rate_table_utilized_cache',
  RATE_TABLE_FETCHED = 'rate_table_fetched',
}
